import { DialogContent } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { DraggableDialog } from '~/components/Dialogs/components/DraggableDialog';
import { SolaForceDialogTitle } from '~/components/SolaForceDialogTitle';
import { AbsenceType } from '~/data/absences/types';
import { AbsenceHistoryDialogContent } from '~/scenes/PeopleModule/components/Tabs/AbsencesTab/components/AbsencesTable/components/AbsenceHistoryDialog/AbsenceHistoryDialogContent';

type PropsType = {
  employeeId: number;
  absenceType: AbsenceType;
  open: boolean;
  onClose: () => void;
};

export const AbsenceHistoryDialog = (props: PropsType) => {
  const { open, employeeId, absenceType, onClose } = props;

  const { t } = useTranslation();

  return (
    <DraggableDialog
      open={open}
      onClose={onClose}
      fullScreen={true}
      showPortalBars={true}
    >
      <SolaForceDialogTitle onClose={onClose}>
        {t(
          absenceType === AbsenceType.LONG
            ? 'laLongTermAbHistory'
            : 'laShortTermAbHistory',
        )}
      </SolaForceDialogTitle>
      <DialogContent>
        {open && (
          <AbsenceHistoryDialogContent
            employeeId={employeeId}
            absenceType={absenceType}
          />
        )}
      </DialogContent>
    </DraggableDialog>
  );
};
